import { collection, addDoc, query, orderBy, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import Input from '../../components/inputs/Input';
import { generateRandomCode } from '../../librairies/Codes';
import { db } from '../../firebase';

function AddChef({onClose}) {


  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");

  //clients
  const [clients, setClients] = useState([]); 
  const [selectedClient, setSelectedClient] = useState(null);

  const [email, setEmail] = useState("");
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [password, setPassword] = useState(generateRandomCode(6));

  const resetState = () => {
    setError("");
    setEmail(""); 
    setPassword("");
  }

  useEffect(() => {
    getClients();
  }, []); 


  /**
   * Récupère l'ensemble des clients
   */
  const getClients = async () => {
    //todo ajouter la verif active 1 dans la query 
    const collectionRef = query(collection(db, "clients"), orderBy("nom"));

    let data = await getDocs(collectionRef); 
    
    if(data !== null){
      setClients(data.docs); 
    }
  }

  /**
   * On submit le formulaire
   * @param {*} e 
   */
  const handleSubmit = async (e)  => {
    e.preventDefault();
    
    try{
      setLoader(true);

      if(selectedClient !== null){
        //on ajoute le nouveau document avec un nouveau compte pour le syndic
        const createChefCollection = collection(db, "create_chef");

        await addDoc(createChefCollection, {
          email: email,
          prenom: prenom,
          nom: nom,
          password: password,
          clientId: selectedClient
        }).catch((err) => {
          setError("Une erreur est survenue, impossible de créer le compte chef");
          setLoader(false);
          return; 
        });

        //le compte du chef est créé grâce à une fonction (cloud functions)
        
        setLoader(false);
        //on remet tous les states par défaut
        resetState(); 

        //on close la popup
        onClose(); 
      }else{
        setError("Aucun client n'a été sélectionnée");
        setLoader(false);
        return; 
      }
    } catch(err){
      setError("Une erreur est survenue, impossible de créer le compte chef");
      setLoader(false);
    }
  };


  return (
    <div id="authentication-modal" tabIndex="-1" aria-hidden="true" className="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div className="relative w-full max-w-md max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button type="button" onClick={onClose} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="px-6 py-6 lg:px-8">
            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Créer un compte chef</h3>

            <form onSubmit={handleSubmit}>

              <div className='mb-6'>
                <div className='text-lg text-primary'>Le client</div>
                <div className='border-b border-gray mt-0.5 mb-2'></div>

                <div>
                  <label for="clients" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Selectionnez un client</label>
                  <select id="clients" onChange={(e) => setSelectedClient(e.target.value)} 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option selected>Sélectionnez un client</option>
                    {clients.length > 0 ? (
                      clients.map((client) => {
                        return (
                          <option key={client.id} value={client.id}>{client.data().nom}</option>
                        )
                      })
                    ) : null }
                  </select>
                </div>
              </div>


              <div className='mb-6'>
                <div className='text-lg text-primary'>Les infos du compte</div>
                <div className='text-sm'>informations du compte Chef</div>
                <div className='border-b border-gray mt-0.5 mb-2'></div>

                <div>
                  <Input id={"prenom"} label={"Prénom"} type={"text"} name={"prenom"} value={prenom} onChange={(event) => setPrenom(event.target.value)}  />
                  <Input id={"nom"} label={"Nom"} type={"text"} name={"nom"} value={nom} onChange={(event) => setNom(event.target.value)}  />
                  <Input id={"email"} label={"Email"} type={"email"} name={"email"} value={email} onChange={(event) => setEmail(event.target.value)}  />
                  <div className='text-sm text-secondary'>Le compte sera créé avec le mot de passe ci-dessous. Veuillez le copier et le transmettre à l'utilisateur. Le mot de passe ne sera pas réaffiché</div>

                  <div className='text-lg text-black font-bold my-2 text-center'>{password}</div>
                </div>
              </div>

              <div className="text-center">
                <PrimaryButton type={"submit"} value={"Créer"} loading={loader} />
              </div>

              {error !== "" ? (
                <p className='justify-center flex my-1 text-red-500'>{error}</p>
              ) : null}
              
            </form>
          </div>
        </div>
      </div>
    </div> 
  );
}

export default AddChef;